import gql from 'graphql-tag';

const storeHours = gql`
  {
    friday {
      open
      close
    }
    monday {
      open
      close
    }
    sunday {
      open
      close
    }
    saturday {
      open
      close
    }
    tuesday {
      open
      close
    }
    thursday {
      open
      close
    }
    wednesday {
      open
      close
    }
  }
`;

const holidayHours = gql`
  {
    holiday
    date
    open
    close
  }
`;

const platformStatus = gql`
  {
    notes
    reason
    status
  }
`;

export const GetStore = gql`
  query Store($storeId: String!) {
    store(storeId: $storeId) {
      id: storeNumber
      amenities {
        name {
          _type
          en
        }
      }
      storeNumber
      storeAddress {
        address1
        address2
        city
        country
        state
        stateProvince
        stateProvinceShort
        postalCode
      }
      dayParts {
        key
        displayName
        hours ${storeHours}
      }
      deliveryHours ${storeHours}
      diningRoomHours ${storeHours}
      driveThruHours ${storeHours}
      curbsideHours ${storeHours}
      deliveryHolidayHours ${holidayHours}
      diningRoomHolidayHours ${holidayHours}
      driveThruHolidayHours ${holidayHours}
      curbsideHolidayHours ${holidayHours}
      franchiseGroupId
      franchiseGroupName
      latitude
      longitude
      phoneNumber
      posVendor
      status
      hasCatering
      hasCurbside
      hasDelivery
      hasDineIn
      hasDriveThru
      hasMobileOrdering
      hasTakeOut
      lastActiveDateTime
      mobileOrderingStatus
      timezone
      storeStatus {
        statuses {
          app ${platformStatus}
          doordash ${platformStatus}
          grubhub ${platformStatus}
          uber ${platformStatus}
        }
      }
    }
  }
`;

export const GetStoreMenuArtifactsMetadata = gql`
  query StoreMenuArtifactsMetadata($storeId: String!, $region: String!) {
    storeMenuArtifactsMetadata(storeId: $storeId, region: $region) {
      bucketName
      exists
      key
      lastModified
      source
    }
  }
`;
